// extracted by mini-css-extract-plugin
export default {"containerBlock":"container_containerBlock__Omr1T"};